// import React, { useEffect, useState, useRef } from 'react';
// import { useSearchParams, useNavigate } from 'react-router-dom';
// import { motion } from 'framer-motion';
// import axios from 'axios';

// const SuccessPage = () => {
//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate();
//   const [status, setStatus] = useState('loading');
//   const [whatsappLink, setWhatsappLink] = useState("");

//   // 🟢 Update: Extract order_id from Cashfree redirect URL
//   const orderId = searchParams.get('order_id');

//   // Track if we've already verified to prevent duplicate API calls/tracking
//   const hasTracked = useRef(false);

//   useEffect(() => {
//     const verifyAndFetchLink = async () => {
//       // 🟢 Cashfree usually redirects back with order_id
//       if (orderId && !hasTracked.current) {
//         try {
//           const API_BASE = process.env.REACT_APP_BACKEND_URL || "https://kshitizfits.onrender.com";
          
//           // 🟢 Hit the updated backend success route
//           const response = await axios.post(`${API_BASE}/api/payment-success`, {
//             order_id: orderId
//           });

//           if (response.data.whatsappLink) {
//             setWhatsappLink(response.data.whatsappLink);
//             setStatus('success');
            
//             // Mark as tracked so it never fires again on re-render
//             hasTracked.current = true;

//             // 🟢 METAPIXEL: Track the actual purchase
//             if (window.fbq) {
//               const amountPaid = response.data.amount || 99; 
//               window.fbq('track', 'Purchase', {
//                 value: amountPaid,
//                 currency: 'INR',
//                 content_name: 'Fitness Community Access',
//                 content_type: 'product'
//               });
//               console.log(`✅ Meta Pixel: Purchase of ₹${amountPaid} tracked!`);
//             }
//           } else {
//             setStatus('failed');
//           }
//         } catch (error) {
//           console.error("Verification Error:", error);
//           setStatus('failed');
//         }
//       } else if (!orderId) {
//         setStatus('invalid');
//       }
//     };

//     verifyAndFetchLink();
//   }, [orderId]);

//   return (
//     <div className="bg-charcoal min-h-screen flex items-center justify-center py-12 px-4">
//       <motion.div 
//         className="max-w-md w-full bg-dark-grey rounded-3xl p-8 text-center shadow-2xl border border-zinc-800"
//         initial={{ opacity: 0, scale: 0.9 }}
//         animate={{ opacity: 1, scale: 1 }}
//         transition={{ duration: 0.5, type: 'spring' }}
//       >
//         {status === 'loading' && (
//           <div className="text-white flex flex-col items-center gap-4">
//             <div className="w-8 h-8 border-4 border-emerald-accent border-t-transparent rounded-full animate-spin"></div>
//             <p className="font-medium">Verifying your payment...</p>
//           </div>
//         )}

//         {status === 'success' && (
//           <>
//             <motion.div 
//               className="w-20 h-20 bg-emerald-accent/20 rounded-full flex items-center justify-center mx-auto mb-6"
//               initial={{ scale: 0 }}
//               animate={{ scale: 1 }}
//               transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
//             >
//               <svg className="w-10 h-10 text-emerald-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
//               </svg>
//             </motion.div>

//             <h1 className="text-3xl font-bold text-white mb-2">Payment Successful!</h1>
//             <p className="text-zinc-400 mb-6">
//               Welcome to the Community. Your access link is ready below.
//             </p>

//             <div className="bg-zinc-800/50 rounded-xl p-4 mb-8 text-left border border-zinc-700">
//               <p className="text-xs text-zinc-500 uppercase tracking-widest mb-1 font-bold">Order ID</p>
//               <p className="text-white font-mono break-all text-xs">{orderId}</p>
//             </div>

//             <motion.a
//               href={whatsappLink}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="block w-full py-4 bg-[#25D366] text-white font-bold text-lg rounded-xl shadow-[0_0_20px_rgba(37,211,102,0.3)] hover:shadow-[0_0_30px_rgba(37,211,102,0.5)] transition-all flex items-center justify-center gap-2"
//               whileHover={{ scale: 1.02 }}
//               whileTap={{ scale: 0.98 }}
//             >
//               <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
//                 <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 00-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
//               </svg>
//               Join WhatsApp Group
//             </motion.a>
//           </>
//         )}

//         {status === 'failed' && (
//           <>
//             <div className="w-20 h-20 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
//               <svg className="w-10 h-10 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M6 18L18 6M6 6l12 12" />
//               </svg>
//             </div>
//             <h1 className="text-3xl font-bold text-white mb-2">Payment Failed</h1>
//             <p className="text-zinc-400 mb-8">
//               We couldn't process your payment or it was cancelled. Please try again.
//             </p>
//             <button
//               onClick={() => navigate('/join')}
//               className="w-full py-4 bg-zinc-800 text-white font-bold rounded-xl hover:bg-zinc-700 transition-colors"
//             >
//               Try Again
//             </button>
//           </>
//         )}

//         {status === 'invalid' && (
//           <div className="text-white">
//             <p className="mb-4 text-zinc-400 font-medium">Invalid request. No order ID found.</p>
//             <button onClick={() => navigate('/')} className="text-emerald-accent underline font-bold">Go Home</button>
//           </div>
//         )}
//       </motion.div>
//     </div>
//   );
// };

// export default SuccessPage;

import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';

const SuccessPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const [whatsappLink, setWhatsappLink] = useState("");

  // Get Instamojo parameters from the URL
  const paymentId = searchParams.get('payment_id');
  const paymentStatus = searchParams.get('payment_status');
  const paymentRequestId = searchParams.get('payment_request_id');

// 1. Add a ref at the top of your component to track if we've already fired
const hasTracked = React.useRef(false);

useEffect(() => {
  const verifyAndFetchLink = async () => {
    // Only run if we haven't successfully verified yet
    if (paymentStatus === 'Credit' && paymentId && !hasTracked.current) {
      try {
        const API_BASE = process.env.REACT_APP_BACKEND_URL || "https://fitnessfreak-44cu.onrender.com";
        const response = await axios.post(`${API_BASE}/api/payment-success`, {
          payment_id: paymentId,
          payment_request_id: paymentRequestId
        });

        if (response.data.whatsappLink) {
          setWhatsappLink(response.data.whatsappLink);
          setStatus('success');
          
          // Mark as tracked so it never fires again on re-render
          hasTracked.current = true;

          if (window.fbq) {
            const amountPaid = response.data.amount || 99; 
            window.fbq('track', 'Purchase', {
              value: amountPaid,
              currency: 'INR',
              content_name: 'Fitness Community Access',
              content_type: 'product'
            });
          }
        } else {
          setStatus('failed');
        }
      } catch (error) {
        setStatus('failed');
      }
    }
  };
  verifyAndFetchLink();
}, [paymentId, paymentStatus, paymentRequestId]);

  return (
    <div className="bg-charcoal min-h-screen flex items-center justify-center py-12 px-4">
      <motion.div 
        className="max-w-md w-full bg-dark-grey rounded-3xl p-8 text-center shadow-2xl border border-zinc-800"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, type: 'spring' }}
      >
        {status === 'loading' && (
          <div className="text-white flex flex-col items-center gap-4">
            <div className="w-8 h-8 border-4 border-emerald-accent border-t-transparent rounded-full animate-spin"></div>
            Verifying your payment...
          </div>
        )}

        {status === 'success' && (
          <>
            <motion.div 
              className="w-20 h-20 bg-emerald-accent/20 rounded-full flex items-center justify-center mx-auto mb-6"
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
            >
              <svg className="w-10 h-10 text-emerald-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
              </svg>
            </motion.div>

            <h1 className="text-3xl font-bold text-white mb-2">Payment Successful!</h1>
            <p className="text-zinc-400 mb-6">
              Welcome to the Community. Your access link is ready below.
            </p>

            <div className="bg-zinc-800/50 rounded-xl p-4 mb-8 text-left border border-zinc-700">
              <p className="text-sm text-zinc-400 mb-1">Transaction ID</p>
              <p className="text-white font-mono break-all text-xs">{paymentId}</p>
            </div>

            <motion.a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full py-4 bg-[#25D366] text-white font-bold text-lg rounded-xl shadow-[0_0_20px_rgba(37,211,102,0.3)] hover:shadow-[0_0_30px_rgba(37,211,102,0.5)] transition-all flex items-center justify-center gap-2"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 00-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
              </svg>
              Join WhatsApp Group
            </motion.a>
          </>
        )}

        {status === 'failed' && (
          <>
            <div className="w-20 h-20 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg className="w-10 h-10 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h1 className="text-3xl font-bold text-white mb-2">Payment Failed</h1>
            <p className="text-zinc-400 mb-8">
              We couldn't process your payment. Please try again.
            </p>
            <button
              onClick={() => navigate('/join')}
              className="w-full py-4 bg-zinc-800 text-white font-bold rounded-xl hover:bg-zinc-700 transition-colors"
            >
              Try Again
            </button>
          </>
        )}

        {status === 'invalid' && (
          <div className="text-white">
            <p className="mb-4 text-zinc-400">Invalid request. No payment details found.</p>
            <button onClick={() => navigate('/')} className="text-emerald-accent underline">Go Home</button>
          </div>
        )}
      </motion.div>
    </div>
  );
};

export default SuccessPage;
